import {
  IsetLoading,
  IsetUserInfo,
  IsetWareHouseList,
  IuserInfo,
  IwarehouseList,
  LOADING,
  USER_INFO,
  WARE_HOUSE_LIST,
} from './types';

/** 使用者登入資訊 */
export const setUserInfoRedux = (payload: IuserInfo): IsetUserInfo => ({
  type: USER_INFO,
  payload,
});

/** 快遞倉站資料 */
export const setWareHouseListRedux = (
  payload: IwarehouseList[]
): IsetWareHouseList => ({
  type: WARE_HOUSE_LIST,
  payload,
});

/** Loading Mask 開關  */
export const setLoadingRedux = (payload: boolean): IsetLoading => ({
  type: LOADING,
  payload,
});
